import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { EMSP_BO_EMSP_USER_LIST_COLUMN_LABEL_I18N_KEY } from '../emsp-bo-emsp-user-list/emsp-bo-emsp-user-list.config';
import { useEmspBoEmspUserListContext } from '../emsp-bo-emsp-user.context';

export const EmspBoEmspUserListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useEmspBoEmspUserListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={EMSP_BO_EMSP_USER_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
